// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --primary: #2563eb;
  --primary-dark: #1d4ed8;
  --primary-light: #eff6ff;
  --accent: #f59e0b;
  --accent-dark: #d97706;
  --success: #10b981;
  --danger: #ef4444;
  --dark: #0f172a;
  --text: #1e293b;
  --text-muted: #64748b;
  --surface: #f8fafc;
  --border: #e2e8f0;
  --white: #ffffff;
  --radius: 12px;
  --radius-sm: 8px;
  --shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  color: var(--text);
  background: var(--white);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

a { color: var(--primary); text-decoration: none; }
a:hover { text-decoration: underline; }

button { cursor: pointer; font-family: inherit; }

input, select, textarea {
  font-family: inherit;
  font-size: 1rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  font-weight: 600;
  border: 2px solid transparent;
  transition: all .2s;
  white-space: nowrap;
}

.btn-primary {
  background: var(--primary);
  color: var(--white);
  border-color: var(--primary);
}
.btn-primary:hover { background: var(--primary-dark); border-color: var(--primary-dark); text-decoration: none; }

.btn-outline {
  background: transparent;
  color: var(--primary);
  border-color: var(--primary);
}
.btn-outline:hover { background: var(--primary-light); text-decoration: none; }

.btn-accent {
  background: var(--accent);
  color: var(--white);
  border-color: var(--accent);
}
.btn-accent:hover { background: var(--accent-dark); border-color: var(--accent-dark); text-decoration: none; }

.btn-lg { padding: 16px 32px; font-size: 1.05rem; }
.btn-sm { padding: 8px 16px; font-size: 0.875rem; }
.btn-block { width: 100%; }

.btn:disabled { opacity: .6; cursor: not-allowed; }

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
}
.badge-accent { background: var(--accent); color: var(--white); }
.badge-primary { background: var(--primary); color: var(--white); }
.badge-success { background: var(--success); color: var(--white); }
.badge-danger { background: var(--danger); color: var(--white); }
.badge-muted { background: var(--border); color: var(--text-muted); }

.card {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 32px;
  box-shadow: var(--shadow);
}

.form-group { margin-bottom: 20px; }
.form-group label { display: block; margin-bottom: 6px; font-weight: 500; font-size: .9rem; color: var(--text); }

.form-control {
  width: 100%;
  padding: 11px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: .95rem;
  color: var(--text);
  background: var(--white);
  transition: border-color .2s;
  outline: none;
}
.form-control:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgb(37 99 235 / .1); }

.alert {
  padding: 14px 18px;
  border-radius: var(--radius-sm);
  font-size: .9rem;
  margin-bottom: 20px;
  border-left: 4px solid;
}
.alert-error { background: #fef2f2; border-color: var(--danger); color: #b91c1c; }
.alert-success { background: #f0fdf4; border-color: var(--success); color: #166534; }
.alert-info { background: #eff6ff; border-color: var(--primary); color: #1e40af; }

.text-center { text-align: center; }
.text-muted { color: var(--text-muted); }
.mt-4 { margin-top: 32px; }

/* Spinner */
.spinner {
  display: inline-block;
  width: 18px; height: 18px;
  border: 2px solid rgba(255,255,255,.3);
  border-top-color: var(--white);
  border-radius: 50%;
  animation: spin .7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,wEAAwE;EACxE,6EAA6E;AAC/E;;AAEA;EACE,mEAAmE;EACnE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,IAAI,qBAAqB,EAAE,qBAAqB,EAAE;AAClD,UAAU,0BAA0B,EAAE;;AAEtC,SAAS,eAAe,EAAE,oBAAoB,EAAE;;AAEhD;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,qBAAqB,+BAA+B,EAAE,iCAAiC,EAAE,qBAAqB,EAAE;;AAEhH;EACE,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;AACA,qBAAqB,gCAAgC,EAAE,qBAAqB,EAAE;;AAE9E;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA,oBAAoB,8BAA8B,EAAE,gCAAgC,EAAE,qBAAqB,EAAE;;AAE7G,UAAU,kBAAkB,EAAE,kBAAkB,EAAE;AAClD,UAAU,iBAAiB,EAAE,mBAAmB,EAAE;AAClD,aAAa,WAAW,EAAE;;AAE1B,gBAAgB,WAAW,EAAE,mBAAmB,EAAE;;AAElD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA,gBAAgB,yBAAyB,EAAE,mBAAmB,EAAE;AAChE,iBAAiB,0BAA0B,EAAE,mBAAmB,EAAE;AAClE,iBAAiB,0BAA0B,EAAE,mBAAmB,EAAE;AAClE,gBAAgB,yBAAyB,EAAE,mBAAmB,EAAE;AAChE,eAAe,yBAAyB,EAAE,wBAAwB,EAAE;;AAEpE;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;AAC3B;;AAEA,cAAc,mBAAmB,EAAE;AACnC,oBAAoB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;;AAEhH;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;EAC5B,aAAa;AACf;AACA,sBAAsB,4BAA4B,EAAE,yCAAyC,EAAE;;AAE/F;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA,eAAe,mBAAmB,EAAE,2BAA2B,EAAE,cAAc,EAAE;AACjF,iBAAiB,mBAAmB,EAAE,4BAA4B,EAAE,cAAc,EAAE;AACpF,cAAc,mBAAmB,EAAE,4BAA4B,EAAE,cAAc,EAAE;;AAEjF,eAAe,kBAAkB,EAAE;AACnC,cAAc,wBAAwB,EAAE;AACxC,QAAQ,gBAAgB,EAAE;;AAE1B,YAAY;AACZ;EACE,qBAAqB;EACrB,WAAW,EAAE,YAAY;EACzB,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;AACrC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE","sourcesContent":["*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n:root {\n  --primary: #2563eb;\n  --primary-dark: #1d4ed8;\n  --primary-light: #eff6ff;\n  --accent: #f59e0b;\n  --accent-dark: #d97706;\n  --success: #10b981;\n  --danger: #ef4444;\n  --dark: #0f172a;\n  --text: #1e293b;\n  --text-muted: #64748b;\n  --surface: #f8fafc;\n  --border: #e2e8f0;\n  --white: #ffffff;\n  --radius: 12px;\n  --radius-sm: 8px;\n  --shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  color: var(--text);\n  background: var(--white);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n}\n\na { color: var(--primary); text-decoration: none; }\na:hover { text-decoration: underline; }\n\nbutton { cursor: pointer; font-family: inherit; }\n\ninput, select, textarea {\n  font-family: inherit;\n  font-size: 1rem;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  font-weight: 600;\n  border: 2px solid transparent;\n  transition: all .2s;\n  white-space: nowrap;\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: var(--white);\n  border-color: var(--primary);\n}\n.btn-primary:hover { background: var(--primary-dark); border-color: var(--primary-dark); text-decoration: none; }\n\n.btn-outline {\n  background: transparent;\n  color: var(--primary);\n  border-color: var(--primary);\n}\n.btn-outline:hover { background: var(--primary-light); text-decoration: none; }\n\n.btn-accent {\n  background: var(--accent);\n  color: var(--white);\n  border-color: var(--accent);\n}\n.btn-accent:hover { background: var(--accent-dark); border-color: var(--accent-dark); text-decoration: none; }\n\n.btn-lg { padding: 16px 32px; font-size: 1.05rem; }\n.btn-sm { padding: 8px 16px; font-size: 0.875rem; }\n.btn-block { width: 100%; }\n\n.btn:disabled { opacity: .6; cursor: not-allowed; }\n\n.badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 50px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n}\n.badge-accent { background: var(--accent); color: var(--white); }\n.badge-primary { background: var(--primary); color: var(--white); }\n.badge-success { background: var(--success); color: var(--white); }\n.badge-danger { background: var(--danger); color: var(--white); }\n.badge-muted { background: var(--border); color: var(--text-muted); }\n\n.card {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 32px;\n  box-shadow: var(--shadow);\n}\n\n.form-group { margin-bottom: 20px; }\n.form-group label { display: block; margin-bottom: 6px; font-weight: 500; font-size: .9rem; color: var(--text); }\n\n.form-control {\n  width: 100%;\n  padding: 11px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: .95rem;\n  color: var(--text);\n  background: var(--white);\n  transition: border-color .2s;\n  outline: none;\n}\n.form-control:focus { border-color: var(--primary); box-shadow: 0 0 0 3px rgb(37 99 235 / .1); }\n\n.alert {\n  padding: 14px 18px;\n  border-radius: var(--radius-sm);\n  font-size: .9rem;\n  margin-bottom: 20px;\n  border-left: 4px solid;\n}\n.alert-error { background: #fef2f2; border-color: var(--danger); color: #b91c1c; }\n.alert-success { background: #f0fdf4; border-color: var(--success); color: #166534; }\n.alert-info { background: #eff6ff; border-color: var(--primary); color: #1e40af; }\n\n.text-center { text-align: center; }\n.text-muted { color: var(--text-muted); }\n.mt-4 { margin-top: 32px; }\n\n/* Spinner */\n.spinner {\n  display: inline-block;\n  width: 18px; height: 18px;\n  border: 2px solid rgba(255,255,255,.3);\n  border-top-color: var(--white);\n  border-radius: 50%;\n  animation: spin .7s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
